import { ModalRoot } from '@cian/ui-kit';
import { ArticleParagraph1 } from '@cian/ui-kit/typography';
import * as React from 'react';

import { DEFAULT_VALUE } from './constants';
import { getNormalizedValue } from './utils';
import { useFiltersContext } from '../../../../packages/Filters/shared/utils/useFiltersContext';
import { getRangeValue } from '../../../../packages/JsonQuery';
import { ETestId } from '../../../common/constants';
import { pluralize } from '../../../common/utils/pluralize';
import { Chip } from '../../components/RedesignedFilters';
import { useAdaptModalToOpenedKeyboard } from '../../hooks/useAdaptModalToOpenedKeyboard';
import { useChip } from '../../hooks/useChip';
import { GuestsModalContainer } from '../GuestsModalContainer';

export const GuestsChipContainer = () => {
  const { jsonQuery } = useFiltersContext();
  const { open, onChipClick, onReset, onCloseWithReset, onApplyClick } = useChip(['beds_count', 'pets', 'kids']);

  const bedrooms = getRangeValue('beds_count')(jsonQuery);
  const guestsCount = getNormalizedValue(bedrooms?.gte) || DEFAULT_VALUE;
  const guestsLabel = `${guestsCount} ${pluralize(guestsCount, ['гость', 'гостя', 'гостей'])}`;

  const { handleModalRef } = useAdaptModalToOpenedKeyboard({ isModalOpen: open });

  return (
    <ModalRoot open={open} onOpenChange={onCloseWithReset}>
      <Chip onClick={onChipClick} testId={ETestId.RedesignedFiltersGuestsChip}>
        <ArticleParagraph1>{guestsLabel}</ArticleParagraph1>
      </Chip>
      <GuestsModalContainer
        onClose={onCloseWithReset}
        onResetClick={onReset}
        onApplyClick={onApplyClick}
        ref={handleModalRef}
      />
    </ModalRoot>
  );
};
